<template>
  <div>
    <div class="site-footer">
      <div class="container-w d-flex">
        <el-row>
          <el-col :span="10" class="footer-row">
            <el-row>
              <el-col :span="8">
                <ul>
                  <li class="t">关于我们</li>
                  <li>
                    <router-link to="/help/helpabout">
                      公司简介
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/help/helpqualification">
                      公司资质
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/help/helpagreement">
                      注册协议
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/help/helpcontact">
                      联系我们
                    </router-link>
                  </li>
                </ul>
              </el-col>
              <el-col :span="8">
                <ul>
                  <li class="t">我要配资</li>
                  <li>
                    <router-link to="/operate/operateday">
                      按天配资
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/operate/operateweek">
                      按周配资
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/operate/operatemonth">
                      按月配资
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/operate/operatehuhui">
                      免息配资
                    </router-link>
                  </li>
                </ul>
              </el-col>
              <el-col :span="8">
                <ul>
                  <li class="t">帮助中心</li>
                  <li>
                    <router-link to="/help/helpguidelines">
                      新手指导
                    </router-link>
                  </li>
                  <li>
                    <!-- <router-link to="/login/register">
                      推广赚钱
                    </router-link> -->
                    <router-link to="/myaccount/agency" v-if="$store.state.loginType">
                      推广赚钱
                    </router-link>
                    <router-link to="/login/register" v-if="!$store.state.loginType">
                      推广赚钱
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/download">
                      APP下载
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/help/helpcenter">
                      常见问题
                    </router-link>
                  </li>
                </ul>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="3" class="qr-list">
            <div class="qr-item">
              <div id="QrCode"></div>
              <span>{{ codes[0].title }}</span>
            </div>
          </el-col>
          <el-col :span="3" class="qr-list">
            <div class="qr-item">

            </div>
          </el-col>
          <el-col :span="6" class="work-info">
            <h3>服务电话</h3>
            <h2>{{ phone[0] }}</h2>
            <h2>{{ phone[1] }}</h2>
            <p>工作时间（08:30-20:30）<br>
              法定节日（13:00-20:00）</p>
          </el-col>
        </el-row>
          <div class="version-text">
         <span style="margin-right: 10px;">版本号 : {{ version }}</span><span>包号 : {{ description }}</span>
       </div>
      </div>
    </div>
    <div class="copyright" style="padding-top:20px;">
      <div class="container-w footer-row">
        <a href="javascript:void(0);"><img src="../assets/img/360.png" height="47px" width="127px" alt=""></a>
        <a href="javascript:void(0);"><img src="../assets/img/kx.png" height="47px" width="127px"></a>
        <!-- <a href="javascript:void(0);"><img src="../assets/img/hy_124x47.png" height="47px" width="127px"></a> -->
        <a href="javascript:void(0);"><img src="../assets/img/gx.png" height="47px" width="127px"></a>
        <a href="javascript:void(0);"><img src="../assets/img/shui.png" height="47px" width="127px"></a>
        <!-- <a href="javascript:void(0);"><img src="../assets/img/shuidi.png" height="47px" width="127px"></a> -->
        <a href="javascript:void(0);"><img src="../assets/img/bdxy.png" height="47px" width="127px"></a>
        <a href="javascript:void(0);"><img src="../assets/img/label_sm_90030.png" height="47px" width="127px"></a>       
      </div>
      <div class="container-w" style="font-size:16px;margin-top:10px;">
        Copyright © {{ copyright }}| All Rights Reserved（投资有风险，入市需谨慎）    </div>
    </div>
  </div>
</template>
<script>
  import QRCode from 'qrcodejs2'
  import { version,description } from './../../package.json';
export default {
  name: "Footer",
  data() {
    return {
      phone: ["", ""], //电话
      codes: [
        { code: "", title: "" },
        { code: "", title: "" },
        { code: "", title: "" }
      ], //微信二维码
      qq: [""], //QQ
      copyright: "", //版权
      link: [], //友情链接
      version:version,
      description:description
    };
  },
  mounted: function() {
    this.getFooterData();
  },
  methods: {
    QrCode(url) {
      new QRCode('QrCode', {
        width: 120,
        height: 120,
        text: url, // 二维码地址
      })
    },
    //获取页面底部信息
    getFooterData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "web_common"
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.phone = data.phone;
            that.codes = data.codes;
            that.qq = data.qq;
            that.copyright = data.copyright;
            that.link = data.link;
            that.QrCode(that.codes[0].code);
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          }
        });
    }
  }
};
</script>
<style scoped>
  @import url("./../assets/css/style.css");

  .footer-row ul{
    margin:0;
    padding:0;
    font-size:16px;
    line-height: 27px;
    text-align: center;
  }
  .footer-row ul li {
    list-style:none;
  }

  .footer-row ul li a{
    color: #fff;
  }

  .footer-row .t{
    font-size:18px;
    font-weight: bolder;
    padding-bottom:5px;
  }
  .version-text{
   font-size: 10px;
   margin-top: 20px;
   color: white  ;
   text-align: center;
   margin-left: auto;
   margin-right: auto;
   margin-bottom: -5px;
 }
</style>





// WEBPACK FOOTER //
// src/components/footer.vue